export default {"src":"/_next/static/media/pause-solid.05d1a019.svg","height":512,"width":320,"blurWidth":0,"blurHeight":0};